import React from "react";
import Layout from "../../layout/Layout";
import { Outlet } from "react-router-dom";

const Projects = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default Projects;
